<template>
    <div class="input-group" :class="{error: hasError}">
        <label v-if="label" :for="identifier">{{label}}</label>
        <Select :id="identifier" :value="value" className="input" :className="className" @input="(v)=>$emit('input', v)"
                :placeholder="placeholder" :disabled="disabled" :options="options" :multiple="multiple"
                :close-on-select="closeOnSelect" :allow-empty="allowEmpty" :label="displayLabel"
                :custom-label="displayCustomLabel" :track-by="trackBy" @updated="()=>$emit('updated')"/>
        <FormErrors v-if="hasError">
            <slot name="errors"></slot>
        </FormErrors>
    </div>
</template>

<script>
    import FormErrors from "./FormErrors";
    import Select from "./Select";
    export default {
        name: "FormInputSelect",
        components: {Select, FormErrors},
        props: {
            value: {
                type: [String, Object, Array],
            },
            identifier: {
                type: String,
                default: null,
            },
            options: {
                type: Array,
                default: () => ([])
            },
            label: {
                type: String,
                default: null,
            },
            displayLabel: {
                type: String,
            },
            displayCustomLabel: {
                default: null,
            },
            trackBy: {
                type: String,
            },
            placeholder: {
                type: String,
                default: null
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            closeOnSelect: {
                type: Boolean,
                default: true,
            },
            allowEmpty: {
                type: Boolean,
                default: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            hasError: {
                type: Boolean,
                default: false
            },
            className: {
                type: String
            }
        }
    }
</script>

<style lang="scss" scoped>
    .input-group {
        @apply w-full flex flex-col items-start mb-5;

        label {
            @apply text-sm text-grey font-bold mb-1;
        }

        &.error {
            .input {
                @apply border-negative;
            }
        }
    }
</style>